/* eslint-disable lingui/no-unlocalized-strings */
export const BRANDING = {
  name: "Apply Edge",
  legalName: "Apply Edge", // Must match LS KYC identity + payout account + footer + invoice descriptor
  address: "Dubai, AE", // Update to exact mailing address before LS application submission
  // Spec 035 — quality-over-volume positioning. See docs/market/positioning.md.
  tagline: "Stop spraying. Start landing.",
  subheadline:
    "Find roles that fit, tailor your resume with AI, track every application, and read the replies — you review and submit. Join 2,000+ job seekers in the beta.",
  stats: {
    candidates: "2,000+",
    interviewMultiplier: "3×",
    avgResumeToReady: "4 min",
    medianAtsScore: "88%",
    templateCount: "18",
  },
  url: "https://apply-edge.com",
  logo: {
    light: "/logo/light.svg",
    dark: "/logo/dark.svg",
    alt: "Apply Edge Logo",
  },
  meta: {
    title: "AI Resume Builder — Create ATS-Friendly Resumes | Apply Edge",
    description:
      "Find roles that fit, tailor your resume to each with AI, track every application, and read the replies. You review and submit. Join the beta.",
  },
  emails: {
    support: "info@apply-edge.com",
  },
};
